class ContactInfoController {
    private onUpdate: any;
    private account: any;

    constructor(private $state: ng.ui.IStateService) {
        'ngInject';
        // console.log('ContactInfoController');
    }

    submitContactInfo() {
        // console.log('update ContactInfo');

        this.onUpdate({ account: this.account });

        (<any>$('#contactInfoModal')).modal('hide');
    }
}

export const contactInfoComponent = {
    bindings: {
        account: '<',
        onUpdate: "&"
    },
    controller: ContactInfoController,
    template: require('./contactInfoModal.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/accounts/contactInfoModal.component.ts